import { Button, Col, Row } from 'antd';
import React, { useState } from 'react';
import mapIcon from '../assets/images/mapLakeIcon.svg';
import MenuDrawer from '../../common/components/menu/MenuDrawer';
import UserLoginForm from '../../common/UserLoginForm';
import '../../common/assets/css/live_availability_calendar.css';
import { Link } from 'react-router-dom';
import LiveAvailabilityCalendarWithControls from '../../common/components/live_availability/LiveAvailabilityCalendarWithControls';

const LiveAvailability = ({
  footerContents,
  setFooterContents,
  onDrawerClose,
  fisheryPublicId,
}) => {
  const [showSignInDrawer, setShowSignInDrawer] = useState(false);

  return (
    <Row>
      <Col className='booking-session-heading h-40 w-full br10 mg-top-0'>
        <img
          src={mapIcon}
          alt={'map icon'}
          style={{
            width: '16px',
            'vertical-align': 'text-top',
          }}
        />
        <span className='white   fs-16 pd-left-10 pd-2'>
          Select a lake below to see live availability
        </span>
      </Col>

      <LiveAvailabilityCalendarWithControls fisheryPublicId={fisheryPublicId} />

      <div className='mg-top-15 w-full'>
        <p className='txt-center gLight  fs-16'>
          Your dates available? Either Sign In or proceed to Book Now
        </p>
        {footerContents === 'sign-in' ? (
          <Button
            className={
              'alt-light-blue-bg  gSemiBold br10 w-full h-fit fs-20 white txt-center  pd-10 pd-left-28 pd-right-28'
            }
            onClick={() => setShowSignInDrawer(true)}
          >
            Sign In
          </Button>
        ) : (
          <Link to={`/booking/new/${fisheryPublicId}`}>
            <Button
              className={
                'light-green-bg gSemiBold br10 w-full h-fit fs-20 white txt-center  pd-10 pd-left-28 pd-right-28'
              }
            >
              Book Now
            </Button>
          </Link>
        )}
      </div>
      <MenuDrawer
        isOpen={showSignInDrawer}
        setIsOpen={setShowSignInDrawer}
        showFooter
      >
        <UserLoginForm useMobileButtonStyle />
      </MenuDrawer>
    </Row>
  );
};

export default LiveAvailability;
